import { UnaryExpression } from "./abstract.unary.expression";
import { FunctionExpression } from "./abstract.functionExpression";
import { ToLowerFunction } from "./toLowerFunction";

export class LikeFunction extends FunctionExpression 
{
    constructor(field: string | UnaryExpression, value: string) 
    {
        super("contains", new ToLowerFunction(field), [value]);
    }
}
